export class CommissionType {
  static types = [
      {value: 0, name: 'BPS'},
      {value: 1, name: 'CPS'},
      {value: 2, name: 'TOTAL'}
    ];
}
